import "./TooltipList.css";

const TooltipList = ({list = [], children}) => {
  return (
    <div className="tooltip-container">
      <span className="tooltip-target">{children}</span>
      {list.length ? <div className="tooltip-box">
        <ul>
          {list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div> : <></>}
    </div>
  );
};

export default TooltipList;
